/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategoryDto } from '../models/category-dto';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProductCategories
   */
  static readonly GetProductCategoriesPath = '/dictionary/product-categories';

  /**
   * Get Product Categories.
   *
   * Load categories assigned to products in the application
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCategories$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CategoryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DictionaryService.GetProductCategoriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategoryDto>>;
      })
    );
  }

  /**
   * Get Product Categories.
   *
   * Load categories assigned to products in the application
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCategories(params?: {
  }): Observable<Array<CategoryDto>> {

    return this.getProductCategories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategoryDto>>) => r.body as Array<CategoryDto>)
    );
  }

  /**
   * Path part for operation getIndustries
   */
  static readonly GetIndustriesPath = '/dictionary/industries';

  /**
   * Get Industries.
   *
   * Load industries registered in the application
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIndustries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIndustries$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DictionaryService.GetIndustriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get Industries.
   *
   * Load industries registered in the application
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIndustries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIndustries(params?: {
  }): Observable<string> {

    return this.getIndustries$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
